import { registerComponent } from "helpers";
import { WYATTPreferredStores } from "wyatt";

registerComponent(
  "store-menu",
  class StoreMenu extends WYATTPreferredStores {
    constructor() {
      super();

      this.address = this.querySelector("[data-store-menu-address]");
      this.name = this.querySelector("[data-store-menu-name]");
      this.phone = this.querySelector("[data-store-menu-phone]");
      this.hours = this.querySelector("[data-store-menu-hours]");

      this.update();
    }

    update() {
      if (!this.preferredStore) {
        return;
      }

      if (this.name) {
        this.name.textContent = this.preferredStore.name;
      }

      if (this.phone) {
        this.phone.textContent = this.preferredStore.phone;
      }

      if (this.hours) {
        this.hours.innerHTML = this.formatHours(this.preferredStore.hours);
      }

      if (this.address) {
        this.address.innerHTML = this.formatAddress(
          this.preferredStore.address,
        );
        this.address.href = this.preferredStore.map_link;
      }
    }

    formatAddress(address) {
      let addressHTML = address.address1;

      if (address.address2) {
        addressHTML += `<br>${address.address2}`;
      }

      if (address.help) {
        addressHTML += `<br>${address.help}`;
      }

      addressHTML += `<br>${address.city}, ${address.province} ${address.zip}`;

      return addressHTML;
    }

    formatHours(hoursData) {
      if (!Array.isArray(hoursData)) {
        return "";
      }

      // Define all days of the week in order
      const allDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];

      // Create a map for quick lookup of hours data
      const hoursMap = {};
      hoursData.forEach((day) => {
        hoursMap[day.day] = day;
      });

      let html = "<dl>";

      allDays.forEach((dayName) => {
        html += `<dt>${dayName}</dt>`;

        if (hoursMap[dayName]) {
          const day = hoursMap[dayName];
          const openTime = this.formatTime(day.open);
          const closeTime = this.formatTime(day.close);
          html += `<dd>${openTime} - ${closeTime}</dd>`;
        } else {
          html += "<dd>Closed</dd>";
        }
      });

      html += "</dl>";
      return html;
    }

    formatTime(time24) {
      // Convert 24-hour format (HH:MM) to 12-hour format (h:mm am/pm)
      const [hours, minutes] = time24.split(":");
      const hour = parseInt(hours, 10);
      const minute = parseInt(minutes, 10);

      let hour12 = hour;
      let ampm = "am";

      if (hour === 0) {
        hour12 = 12;
      } else if (hour === 12) {
        ampm = "pm";
      } else if (hour > 12) {
        hour12 = hour - 12;
        ampm = "pm";
      }

      // Format minutes (remove leading zero if minutes is 0)
      const minuteStr =
        minute === 0 ? "" : `:${minute.toString().padStart(2, "0")}`;

      return `${hour12}${minuteStr} ${ampm}`;
    }
  },
);
